import { Badge as AntdBadge, BadgeProps as AntdBadgeProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface BadgeProps extends AntdBadgeProps {}

export const badgePrefixCls = `${CMP_PREFIX}-badge`;

export const Badge = ({ ...props }: BadgeProps) => {
  return <AntdBadge {...props} />;
};
